import { DEFAULT_CHAT_PRICE, DEFAULT_OFFLINE_QUESTION_PRICE } from '@packages/shared/core/common/constants/appDefaults';
import { Expert, ExpertReview } from '@packages/shared/core/experts/entities';
import { convertCredits } from '@packages/shared/core/common/entities';
import { ExpertDto, ExpertReviewDto } from '../services/dto';
import { mapSupplyTypeDtoToEntity } from './mapSupplyTypeDtoToEntity';

export function mapChatOffersDtoToPrices(chatOffersDto: ExpertDto['chat_offers']) {
  const onlineOffer = chatOffersDto.find((offer) => offer.type === 'online');
  const chatPrice = onlineOffer ? onlineOffer.price : DEFAULT_CHAT_PRICE;

  const offlineOffer = chatOffersDto.find((offer) => offer.type === 'offline');
  const offlineQuestionPrice = offlineOffer ? offlineOffer.price : DEFAULT_OFFLINE_QUESTION_PRICE;

  return {
    chatPrice,
    chatPriceInCredits: convertCredits(chatPrice),
    offlineQuestionPrice,
    offlineQuestionPriceInCredits: convertCredits(offlineQuestionPrice),
  };
}

export function mapExpertDtoToEntity(expert: ExpertDto): Expert {
  const chatOffers = Array.isArray(expert.chat_offers) ? expert.chat_offers : [];

  const { chatPrice, chatPriceInCredits, offlineQuestionPrice, offlineQuestionPriceInCredits } =
    mapChatOffersDtoToPrices(chatOffers);

  return {
    ...expert,
    specialization: 'Love & Relationship expert',
    chatPrice,
    chatPriceInCredits,
    offlineQuestionPrice,
    offlineQuestionPriceInCredits,
    supplyType: mapSupplyTypeDtoToEntity(expert.supply_type),
  };
}

export function mapReviewDtoToEntity(dto: ExpertReviewDto): ExpertReview {
  return {
    id: dto.id,
    text: dto.text,
    rating: dto.rating,
    created_at: dto.created_at,
    customer: {
      name: dto.customer.name || '',
    },
  };
}
